export { MobileCard } from './MobileCard';
